import React from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
    title: string;
    description: string;
    canonicalPath?: string;
    structuredData?: Record<string, any>;
    socialImagePath?: string;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    canonicalPath = "",
    structuredData,
    socialImagePath = "/images/social/default-preview.png",
}) => {
    const siteName = "DevsBestFriend";
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    const baseUrl = "https://devsbestfriend.com";
    const url = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;
    const fullImagePath = `${baseUrl}${socialImagePath}`;

    return (
        <Helmet>
            {/* Basic meta tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImagePath} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={fullImagePath} />

            {/* JSON-LD structured data */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
